import { Configuration, PopupRequest } from "@azure/msal-browser";

const localconfig = {
    clientId: process.env.REACT_APP_ORGINPICK_CLIENTID || "",
    authority: process.env.REACT_APP_ORGINPICK_AUTHORITY || "",
    redirectUri: process.env.REACT_APP_ORGINPICK_REDIRECT_URI || "",
    postLogoutRedirectUri: process.env.REACT_APP_ORGINPICK_POST_LOGOUT_REDIRECT_URI || "",
    scopes: [process.env.REACT_APP_ORGINPICK_SCOPES || ""]
}

const prodconfig = {
    clientId: "#{clientId}#",
    authority: "https://login.microsoftonline.com/#{tenantId}#",
    redirectUri: "#{redirectUrl}#",
    postLogoutRedirectUri: "/",
    scopes: ["api://#{apiAppId}#/OriginPick.Read"]
}
const config = window.location.hostname === "localhost";

export const msalConfig: Configuration = {
    auth: {
        clientId: config ? localconfig.clientId : prodconfig.clientId,
        authority: config ? localconfig.authority : prodconfig.authority,
        redirectUri: config ? localconfig.redirectUri : prodconfig.redirectUri,
        postLogoutRedirectUri: config ? localconfig.postLogoutRedirectUri : prodconfig.postLogoutRedirectUri
    }
};

export const loginRequest: PopupRequest = {
    scopes: config ? localconfig.scopes : prodconfig.scopes
};

export const isConsoleOn = config?process.env.REACT_APP_ORGINPICK_CONSOLE_MESSAGE:"#{isConsoleOn}#"